// extracted by mini-css-extract-plugin
var _1 = "ListDemo_pointWrapper__c33e4";
export { _1 as "pointWrapper" }
